<template>
  <div class="businessTripPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.applicantIdName"
        v-if="mode != 'add'"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <!-- 所属项目 -->
    <van-cell-group class="itemSite beizhu">
      <van-field
        v-model="businessInput.projectName"
        :required="editType"
        type="textarea"
        label="所属项目："
        :placeholder="editType ? '请选择' : ''"
        @click="checkItemPicker"
        :is-link="editType"
        readonly
        class="ggInput"
        rows="1"
        autosize
      />
    </van-cell-group>
    <!-- 外出开始时间 -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.startTime"
        :required="editType"
        label="外出开始时间："
        readonly
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="TimePicker(1)"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="businessInput.endTime"
        :required="editType"
        label="外出结束时间："
        readonly
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="TimePicker(2)"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="businessInput.reason"
        rows="1"
        autosize
        :required="editType"
        label="事由/原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="editType == true ? false : true"
      />
    </van-cell-group>
    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && businessInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="businessInput"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && businessInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="businessInput"></flow-staff>
      <flow-list :workflowCode="businessInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="businessInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="businessInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="businessInput.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        businessInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          businessInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          businessInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">审批</van-button>
    </div>
    <!-- 弹出层 -->
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
      />
    </van-popup>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPagePicker" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const projectView = () => import("@/components/businessTripMould/projectView");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
import {
  dateTimeFormat,
  intervalTime,
  diffMonth,
  getCurData,
  getDictList,
  isEdit,
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "businessTrip",
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      verifyPageType: false, //审批弹框,默认不显示

      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      businessInput: {
        // id: "",
        applicantId: "", //申请人id
        applicantIdName: "", //申请人姓名
        projectId: "", //项目编号
        projectName: "", //项目名称
        startTime: "", //外出开始时间
        endTime: "", //外出结束时间
        reason: "", //事由/原因
        verifyStatus: "hold", //详情的当前状态
      },
      showItemPicker: false, //所属项目弹框
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(getCurData()),
      checkIndex: "", // 时间
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(),
    };
  },
  components: {
    projectView,
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  async mounted() {
    if (is_wei()) {
      document.title = "外出申请";
    }

    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.businessInput.applicantIdName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.businessInput.applicantId =
          this.mode == "add" ? this.userinfo.id : "";
      }
      console.log(this.mode !== "add",this.commonId)
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
      if (this.mode == "add" && this.userinfo && this.userinfo.id) {
        console.log(this.userinfo, "userinfo");
        let selfList = [this.userinfo];
        window.sessionStorage.setItem("moreRetinueList",JSON.stringify(selfList));
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.outing
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.businessInput = res.data;
            if (
              (_this.businessInput.verifyStatus == "hold" ||
                _this.businessInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    /*显示所属项目控件*/
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    /*获取所属项目数据*/
    setProject(data) {
      if (data != "") {
        this.businessInput.projectId = data.id;
        this.businessInput.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    /*获取时间控件*/
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        this.showTimePicker = true;
      }
    },
    /*获取时间数据*/
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkIndex == "1") {
        this.businessInput.startTime = dateTimeFormat(data);
      } else {
        this.businessInput.endTime = dateTimeFormat(data);
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      /*校验*/

      if (
        _this.businessInput.applicantId &&
        _this.businessInput.projectId &&
        _this.businessInput.startTime &&
        _this.businessInput.endTime &&
        _this.businessInput.reason
      ) {
        _this.mode = msg;
        console.log('=====33=====',_this.businessInput.endTime,_this.businessInput.startTime,new Date(_this.businessInput.endTime)<new Date(_this.businessInput.startTime))
        let endTime=_this.businessInput.endTime.replace(/-/g, '/');
        let startTime=_this.businessInput.startTime.replace(/-/g, '/');
        if(new Date(endTime)<new Date(startTime)){
          _this.$toast("返回时间不能小于开始时间");
        }else{
          _this.saveAll();
        }
        
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.outing
        .busSave(_this.mode, _this.businessInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;

      let msg = _this.businessInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.outing
            .operate(_this.businessInput.verifyStatus, _this.businessInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.businessInput.applicantIdName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.businessInput.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.businessTripPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
  .van-field__label{
    width: 130px;
    
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .van-cell,
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      height: 45px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        display: inline-block;
        height: 45px;
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
}
</style>